/*-----------------------------------------------------------------------------/
/ Custom Theme JS - Animation des oiseaux au scroll
/-----------------------------------------------------------------------------*/

///OISEAUX///
(function () {
  var layout = document.querySelector('.content-for-layout');
  if (!layout) return;

  var windowHeight = layout.offsetHeight;
  var windowWidth = window.innerWidth;

  window.addEventListener('scroll', function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

    //OISEAU7--------------------------------------------------
    var scrollPercent = scrollTop / 500 || 0;
    var start = 100;
    var OISEAU7 = document.getElementById('oiseau7');

    if (OISEAU7) {
      if (this.oldScroll > window.pageYOffset) {
        OISEAU7.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-9.png?v=1616601774')";
      } else {
        OISEAU7.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-7.png?v=1616209279')";
      }

      OISEAU7.style.bottom = (start + (scrollPercent * windowWidth) / 2) + 'px';
      OISEAU7.style.right = 0 + '%';
      OISEAU7.style.left = (scrollPercent * windowHeight) + 'px';
      OISEAU7.style.opacity = window.pageYOffset / 200;
      OISEAU7.style.position = 'fixed';
      OISEAU7.style.height = 100 + 'px';
      OISEAU7.style.width = 100 + 'px';
      OISEAU7.style.backgroundSize = 'contain';
      OISEAU7.style.backgroundRepeat = 'no-repeat';
    }
    //FIN OISEAU7-----------------------------------------------

    //OISEAU2--------------------------------------------------
    var OISEAU2 = document.getElementById('oiseau2');

    if (OISEAU2) {
      if (this.oldScroll > window.pageYOffset) {
        OISEAU2.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-6.png?v=1616209279')";
      } else {
        OISEAU2.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-8.png?v=1616301612')";
      }

      OISEAU2.style.bottom = (start + (scrollPercent * windowWidth) / 2) + 'px';
      OISEAU2.style.right = 0 + '%';
      OISEAU2.style.left = ((scrollPercent / 2) * windowHeight) / 2 + 'px';
      OISEAU2.style.opacity = window.pageYOffset / 200;
      OISEAU2.style.position = 'fixed';
      OISEAU2.style.height = 100 + 'px';
      OISEAU2.style.width = 100 + 'px';
      OISEAU2.style.backgroundSize = 'contain';
      OISEAU2.style.backgroundRepeat = 'no-repeat';
      OISEAU2.style.marginBottom = '-100%';
    }
    //FIN OISEAU2-----------------------------------------------

    //OISEAU3--------------------------------------------------
    var OISEAU3 = document.getElementById('oiseau3');

    if (OISEAU3) {
      if (this.oldScroll > window.pageYOffset) {
        OISEAU3.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-2.png?v=1616209279')";
      } else {
        OISEAU3.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-10.png?v=1616601782')";
      }

      OISEAU3.style.top = (start + (scrollPercent * windowWidth) / 60) + 'px';
      OISEAU3.style.right = 0 + '%';
      OISEAU3.style.left = ((scrollPercent / 2) * windowHeight) / 5 + 'px';
      OISEAU3.style.opacity = window.pageYOffset / 200;
      OISEAU3.style.position = 'fixed';
      OISEAU3.style.height = 100 + 'px';
      OISEAU3.style.width = 100 + 'px';
      OISEAU3.style.backgroundSize = 'contain';
      OISEAU3.style.backgroundRepeat = 'no-repeat';
      OISEAU3.style.marginBottom = '-60%';
    }
    //FIN OISEAU3-----------------------------------------------

    //OISEAU4--------------------------------------------------
    var OISEAU4 = document.getElementById('oiseau4');

    if (OISEAU4) {
      if (this.oldScroll > window.pageYOffset) {
        OISEAU4.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-8.png?v=1616301612')";
      } else {
        OISEAU4.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-6.png?v=1616209279')";
      }

      OISEAU4.style.right = 0 + '%';

      if (scrollPercent < 20) {
        OISEAU4.style.opacity = 0;
        OISEAU4.style.top = 0 + 'px';
        OISEAU4.style.left = 0 + '%';
      } else {
        OISEAU4.style.top = (start + (scrollPercent * windowWidth) / 60) + 'px';
        OISEAU4.style.opacity = window.pageYOffset / 200;
        OISEAU4.style.left = (120 - (scrollPercent * 2)) + '%';
      }

      OISEAU4.style.position = 'fixed';
      OISEAU4.style.height = 100 + 'px';
      OISEAU4.style.width = 100 + 'px';
      OISEAU4.style.backgroundSize = 'contain';
      OISEAU4.style.backgroundRepeat = 'no-repeat';
    }
    //FIN OISEAU4-----------------------------------------------

    //OISEAU5--------------------------------------------------
    var OISEAU5 = document.getElementById('oiseau5');

    if (OISEAU5) {
      if (this.oldScroll > window.pageYOffset) {
        OISEAU5.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-6.png?v=1616209279')";
      } else {
        OISEAU5.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0410/2144/0153/files/OISEAUX-8.png?v=1616301612')";
      }

      if (scrollPercent < 4) {
        OISEAU5.style.opacity = 0;
        OISEAU5.style.left = 0 + 'px';
        OISEAU5.style.bottom = 0 + 'px';
      } else {
        OISEAU5.style.opacity = window.pageYOffset / 200;
        OISEAU5.style.left = ((scrollPercent / 2) * windowHeight) / 20 + 'px';
        OISEAU5.style.bottom = ((scrollPercent * windowWidth) / 20) + 'px';
      }

      OISEAU5.style.right = 0 + '%';
      OISEAU5.style.position = 'fixed';
      OISEAU5.style.height = 100 + 'px';
      OISEAU5.style.width = 100 + 'px';
      OISEAU5.style.backgroundSize = 'contain';
      OISEAU5.style.backgroundRepeat = 'no-repeat';
    }
    //FIN OISEAU5-----------------------------------------------

    this.oldScroll = window.pageYOffset;
  });
})();
///FIN OISEAUX///
